const CheckIcon = () => {
  return (
    <svg
      width="23"
      height="17"
      viewBox="0 0 23 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 7L9.11069 14.1107L21.8318 1.38956"
        stroke="white"
        strokeWidth="3"
      />
    </svg>
  );
};

export default CheckIcon;
